/// <reference path="../../../../../node_modules/@ms/office-online-strings/en-US/transcription-strings.d.ts" />
import * as React from 'react';
import * as AppMicWidgetStyle from './AppMicWidget.styles';
import { FontIcon, mergeStyles } from 'office-ui-fabric-react';
import { AppMicWidgetProps, AppMicWidgetRecorderState } from './AppMicWidget.props';
import { AddTooltipToElement } from '../../Tooltip/AddTooltipToElement';

export class AppMicWidget extends React.PureComponent<AppMicWidgetProps> {

  constructor(props: AppMicWidgetProps) {
    super(props);
  }

  public render() {
    const appMicWidget = this._getAppMicWidget();

    return (
      <div style={AppMicWidgetStyle.getMicWidgetContainerCSSProperties()}>
        {appMicWidget}
      </div>
    );
  }

  private _getAppMicWidget() {
    // At present no pulsing animations is supported and hence return mic widget without pulsing.
    let appMicWidget = this._getMicWidgetWithoutPulsing();
    return appMicWidget;
  }

  private _getMicWidgetWithoutPulsing() {
    const { isEnabled, currentMicState } = this.props;

    const mergedStyle = this._getMergedStyleForMicWidget(isEnabled, currentMicState);
    const fontIconName = this._getFontIconNameForMicWidget(currentMicState);
    const tooltipName = this._getTooltipNameForMicWidget(currentMicState);

    return (
      AddTooltipToElement(<button aria-labelledby="RecordingStatusLabel" aria-label={tooltipName} className={mergedStyle} onClick={this._onMicWidgetClicked}>
        <FontIcon iconName={fontIconName} className={AppMicWidgetStyle.getMicWidgetIconStyles(fontIconName)} />
      </button>, tooltipName)
    );
  }

  private _getMergedStyleForMicWidget(isEnabled: boolean, currentMicState: AppMicWidgetRecorderState) {
    let style = AppMicWidgetStyle.getMicWidgetStyle();

    if (isEnabled) {
      style = mergeStyles(style, AppMicWidgetStyle.getEnabledMicWidgetStyle());
    } else {
      style = mergeStyles(style, AppMicWidgetStyle.getDisabledMicWidgetStyle());
    }

    style = mergeStyles(style, this._getPartialStyleForMicWidgetInCurrentState(currentMicState));

    return style;
  }

  private _getPartialStyleForMicWidgetInCurrentState(currentMicState: AppMicWidgetRecorderState) {
    switch (currentMicState) {
      case AppMicWidgetRecorderState.Recording:
        return AppMicWidgetStyle.getRecordingMicWidgetStyle();

      case AppMicWidgetRecorderState.Paused:
        return AppMicWidgetStyle.getPausedMicWidgetStyle();

      default:
        return AppMicWidgetStyle.getPausedMicWidgetStyle();
    }
  }

  private _getFontIconNameForMicWidget(currentMicState: AppMicWidgetRecorderState) {
    switch (currentMicState) {
      case AppMicWidgetRecorderState.Recording:
        return AppMicWidgetStyle.RecordingStateIconName;

      case AppMicWidgetRecorderState.Paused:
        return AppMicWidgetStyle.PausedStateIconName;

      default:
        return AppMicWidgetStyle.PausedStateIconName;
    }
  }

  private _getTooltipNameForMicWidget(currentMicState: AppMicWidgetRecorderState) {
    switch (currentMicState) {
      case AppMicWidgetRecorderState.Recording:
        return TranscriptionStrings.RecordingNonPausedLabel;

      case AppMicWidgetRecorderState.Paused:
        return TranscriptionStrings.RecordingPausedLabel;

      default:
        return "";
    }
  }

  private _onMicWidgetClicked = async (): Promise<void> => {
    const { onMicWidgetClicked } = this.props;

    if (onMicWidgetClicked) {
      onMicWidgetClicked();
    }
  };
}